var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNagotiationP(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33352 12.8338V2.4626C9.33352 2.11877 9.21059 1.78903 8.99178 1.54591C8.77297 1.30278 8.4762 1.1662 8.16676 1.1662H5.83324C5.5238 1.1662 5.22703 1.30278 5.00822 1.54591C4.78941 1.78903 4.66648 2.11877 4.66648 2.4626V12.8338M2.33296 3.759H11.667C12.3114 3.759 12.8338 4.33942 12.8338 5.0554V11.5374C12.8338 12.2534 12.3114 12.8338 11.667 12.8338H2.33296C1.68858 12.8338 1.1662 12.2534 1.1662 11.5374V5.0554C1.1662 4.33942 1.68858 3.759 2.33296 3.759Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNagotiationP);
export default __webpack_public_path__ + "static/media/nagotiationP.bffc0caecdd30b852b2f1a1a799d0852.svg";
export { ForwardRef as ReactComponent };